import React from "react";

export const Spinner: React.FC<{ className?: string; size?: "xs" | "sm" }> = ({
  className = "",
  size = "sm",
}) => (
  <div
    className={`animate-spin rounded-full ${size === "xs" ? "icon-xs" : "icon-sm"} border-2 border-accent/30 border-t-accent/50 ${className}`}
  />
);
